import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ${className}`}>
            {value}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" />
        </label>
    )
}